export enum VirtualBackgroundsTypes {
  Blue = 'image',
  Blur = 'blur',
  LightCool = 'lightCool',
  LightNeutral = 'lightNeutral',
  LightWarm = 'lightWarm',
  None = 'none'
}
